import { useState } from "react";
import PretendardText from "../../../atoms/text/pretendardText";
import MainInput from "../../../atoms/input/mainInput";
import Popup from "../../../molecules/popup";
import PopupOverLay from "../../PopupOverlay";
import TextArea from "../../../atoms/input/textarea";
// import GrayBtn from "../../../atoms/button/grayBtn";
import MemberApi from "../../../../api/member.api";
import { toast } from "react-toastify";
import { toastMsg } from "../../../../util/toastMsg";
import { errorHandler } from "../../../../util/errorHandler";

const SMSSendPopup = ({
  setPopupOpen,
  userCheckedIdList,
  getMemberList,
  sessionStorageInit,
  setButtonGroupOpen,
}) => {
  // SMS 보내기 관련
  // const [myNumberVerified, setMyNumberVerified] = useState(false);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const smsSendFunc = async () => {
    try {
      let membersPhoneNumberTemp = userCheckedIdList.map(
        (item) => item.phoneNumber
      );

      const data = {
        phoneNumberList: membersPhoneNumberTemp,
        title: title,
        content: content,
      };

      await MemberApi.smsSend(data);

      getMemberList();
      toast(toastMsg.create);
      setButtonGroupOpen(false);
      sessionStorageInit();
      setPopupOpen(false);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <PopupOverLay
      isOpen={true}
      onClick={() => {
        setPopupOpen(false);
      }}
    >
      <Popup
        style={{
          width: 632,
        }}
        headerTitle="SMS 보내기"
        footerBtnText="보내기"
        onClick={() => {
          setPopupOpen(false);
        }}
        footerBtnHandler={() => {
          smsSendFunc();
        }}
      >
        <div
          // className="custom-scrollbar"
          style={{
            width: "100%",
            // height: 350,
            // overflowY: "auto",
            padding: "0px 30px",
            margin: "24px 0px 20px 0px",
            display: "flex",
            flexDirection: "column",
            gap: 24,
          }}
        >
          {/* 발송대상 */}
          <div
            style={{
              width: "100%",
              height: "fit-content",
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            <PretendardText
              style={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              발송대상
            </PretendardText>
            <PretendardText
              style={{
                fontSize: "15px",
                fontWeight: "400",
                lineHeight: "21.25px",
                color: "#aaa",
              }}
            >
              {userCheckedIdList.map((item, index) => {
                if (userCheckedIdList.length === index + 1) {
                  return item.phoneNumber.replace(
                    /(\d{3})(\d{4})(\d{4})/,
                    "$1-$2-$3"
                  );
                } else {
                  return `${item.phoneNumber.replace(
                    /(\d{3})(\d{4})(\d{4})/,
                    "$1-$2-$3"
                  )}, `;
                }
              })}
            </PretendardText>
          </div>

          {/* 보내는 번호(내번호) */}
          <div
            style={{
              width: "100%",
              height: "fit-content",
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            <PretendardText
              style={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              보내는 번호(내번호)
            </PretendardText>
            <PretendardText
              style={{
                fontSize: "15px",
                fontWeight: "400",
                lineHeight: "21.25px",
                color: "#aaa",
              }}
            >
              010-9876-5432
            </PretendardText>
            {/* {!myNumberVerified && (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <PretendardText
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                      lineHeight: "22.75px",
                      color: "#cf6679",
                    }}
                  >
                    미인증
                  </PretendardText>
                  <GrayBtn
                    onClick={() => {
                      setMyNumberVerified(true);
                    }}
                  >
                    발신번호 인증
                  </GrayBtn>
                </div>
                <PretendardText
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    lineHeight: "22.75px",
                    color: "#cf6679",
                  }}
                >
                  전기통신사업법에 따라 유효한 번호로만 발신 가능하며, 인증 후
                  SMS 사용이 가능합니다
                </PretendardText>
              </>
            )} */}
          </div>

          {/* 제목 */}
          <div
            style={{
              width: "100%",
              height: "fit-content",
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}
          >
            <PretendardText
              style={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              제목
            </PretendardText>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
              }}
            >
              <MainInput
                type={"text"}
                placeholder={"내용을 입력해주세요"}
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
                maxLength={40}
              />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <PretendardText
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    lineHeight: "18.75px",
                    color: "rgba(181, 181, 181, 0.5)",
                  }}
                >
                  제목은 LMS로 발송 시에만 최대 40바이트까지 전송됩니다. (미입력
                  시 사이트명으로 표기)
                </PretendardText>
                <PretendardText
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    lineHeight: "18.75px",
                    color: "rgba(181, 181, 181, 0.5)",
                  }}
                >
                  {title.length}/40
                </PretendardText>
              </div>
            </div>
          </div>

          {/* 내용 */}
          <div
            style={{
              width: "100%",
              height: "fit-content",
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}
          >
            <PretendardText
              style={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              내용
            </PretendardText>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
              }}
            >
              <TextArea
                type={"text"}
                placeholder={"(광고)"}
                maxLength={90}
                style={{
                  width: "572px",
                  minHeight: "107px",
                }}
                value={content}
                onChange={(e) => {
                  setContent(e.target.value);
                }}
              />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <PretendardText
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    lineHeight: "18.75px",
                    color: "rgba(181, 181, 181, 0.5)",
                  }}
                >
                  {content.length}/90
                </PretendardText>
              </div>
            </div>
          </div>
        </div>
      </Popup>
    </PopupOverLay>
  );
};

export default SMSSendPopup;
